import TutorialCompletedPopup from './TutorialCompletedPopup';

export default TutorialCompletedPopup;
